module.exports = __webpack_public_path__ + "amas.jpg?fcc633c6c4b8e52881da35bd77cdad47";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projetos/amas.jpg
// module id = 103
// module chunks = 0